import { apiPlugin, storyblokInit } from "@storyblok/js";

export const allowVisualEditor = () =>
  process.env.NEXT_PUBLIC_ALLOW_VISUAL_EDITOR === "yes";

const { storyblokApi } = storyblokInit({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN,
  use: [apiPlugin],
  bridge: allowVisualEditor(),
  apiOptions: {
    fetch: (input, init = {}) =>
      fetch(input, {
        ...init,
        cache: allowVisualEditor() ? "no-cache" : "force-cache",
      }),
  },
});

export const createStoryblok = () => {
  if (storyblokApi === undefined)
    throw new Error("Connection with Storyblok couldn't be established.");

  return storyblokApi;
};
